import { render } from "./EditBox.vue?vue&type=template&id=f5fd7be6"
import script from "./EditBox.vue?vue&type=script&lang=js"
export * from "./EditBox.vue?vue&type=script&lang=js"

import exportComponent from "/Users/joecortinhas/Documents/code/DigitalLaborSolutions/dlstracker_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__